export const SITE_URL = "https://sagittariusmotorworks.co.nz";

export const HOME_SEO = {
  title: "Mechanic & BMW Specialist Mount Maunganui | Sagittarius Motor Works",
  description:
    "Mechanic in Mount Maunganui, Tauranga. Car servicing, repairs, BMW diagnostics and coding, plus 24/7 breakdown help. Open 7 days. Call 022 566 5221.",
};

export const SEO_PAGES = {
  "/our-services": {
    title: "Car Servicing & Repairs Mount Maunganui | Sagittarius Motor Works",
    description:
      "Car servicing and repairs in Mount Maunganui: scheduled servicing, brakes, suspension, clutches, timing, diagnostics. Fixed quote first. Open 7 days.",
    h1: "Car Servicing & Repairs in Mount Maunganui",
    eyebrow: "Our services",
    body: [
      "Need a mechanic in Mount Maunganui or Tauranga? We handle scheduled servicing, brakes, suspension, clutches and timing work, plus engine and electrical fault finding. You get a fixed quote before any work starts, OEM-or-better parts itemised on the invoice, and a written report you can actually understand. Every job is logged in your online service history. Book online or call 022 566 5221.",
    ],
  },
  "/bmw-coding-programming": {
    title: "BMW Coding & Programming Tauranga | Sagittarius Motor Works",
    description:
      "BMW coding, programming and dealer-level ISTA+ diagnostics in Mount Maunganui, Tauranga. Japanese-import nav converted to NZ maps. Call 022 566 5221.",
    h1: "BMW Diagnostics, Coding & Programming in Tauranga",
    eyebrow: "BMW specialists",
    body: [
      "We're BMW specialists in Mount Maunganui. Using dealer-level ISTA+ diagnostics we read every module in your BMW and trace faults to the real cause. We code and program replacement modules, handle adaptations and software updates in-house, and convert Japanese-import iDrive systems to New Zealand maps, English language and NZ radio bands. Tell us your model and what you need, and we'll confirm what's possible. Call 022 566 5221.",
    ],
  },
  "/breakdown-help": {
    title: "24/7 Breakdown Help Tauranga | Sagittarius Motor Works",
    description:
      "Broken down in Tauranga or Mount Maunganui? Call our 24/7 breakdown line on 022 566 5221 or 027 362 6970. Warning lights, no-starts, flat batteries.",
    h1: "24/7 Breakdown Help in Tauranga and Mount Maunganui",
    eyebrow: "Breakdown line — 24/7",
    body: [
      "Broken down, day or night? Call 022 566 5221 or 027 362 6970. Tell us where you are and what happened, and we'll talk you through the next steps and help get you back on the road. Warning lights, no-starts, flat batteries and sudden loss of power are all things we deal with. Save our number now so you've got it when you need it.",
    ],
  },
  "/about-us": {
    title: "About Sagittarius Motor Works | Independent Mechanic, Mount Maunganui",
    description:
      "Independent car repair workshop and BMW specialist in Mount Maunganui, established 2025. Open 7 days, 8am–5:30pm at 9 Cherokee Place.",
    h1: "About Sagittarius Motor Works",
    eyebrow: "Est. 2025",
    body: [
      "Sagittarius Motor Works opened in Mount Maunganui in 2025 as an independent car repair workshop with a BMW specialty. Our approach is simple: find the real cause, quote before we start, and do every repair once and properly. You'll find us at Unit 1, 9 Cherokee Place, open 7 days from 8:00am to 5:30pm.",
    ],
  },
  "/contact": {
    title: "Contact & Book | Sagittarius Motor Works, Mount Maunganui",
    description:
      "Book a mechanic in Mount Maunganui. Unit 1, 9 Cherokee Place. Open 7 days 8am–5:30pm. Call or WhatsApp 022 566 5221, or 027 362 6970.",
    h1: "Contact & Book Sagittarius Motor Works",
    eyebrow: "Contact",
    body: [
      "Unit 1, 9 Cherokee Place, Mount Maunganui 3116. Open 7 days, 8:00am–5:30pm. Breakdown line 24/7. Phone/WhatsApp 022 566 5221, or 027 362 6970.",
    ],
    showBooking: true,
  },
};

export const NOINDEX_PREFIXES = ["/admin", "/portal", "/payment"];

export const SEO_NAV = [
  { to: "/our-services", label: "Services" },
  { to: "/bmw-coding-programming", label: "BMW Coding" },
  { to: "/breakdown-help", label: "Breakdown" },
  { to: "/about-us", label: "About" },
  { to: "/contact", label: "Contact" },
];
